import { render } from "./MiniChatWrap.vue?vue&type=template&id=cb163ada"
import script from "./MiniChatWrap.vue?vue&type=script&lang=js"
export * from "./MiniChatWrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/common/header/parts/MiniChatWrap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cb163ada"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb163ada', __exports__)) {
    api.reload('cb163ada', __exports__)
  }
  
  module.hot.accept("./MiniChatWrap.vue?vue&type=template&id=cb163ada", () => {
    api.rerender('cb163ada', render)
  })

}


export default __exports__